import axios from "axios";
import appconst from "./appconst";
import Vue from "vue";
import url from "./url";
import store from "../store";
// import vcClaimStore from "src/store/modules/vcClaim";
import Util from "@/lib/util";
import swal from "sweetalert";
import { L } from "@/asdcom/BaseComponent";
import util from "@/lib/util";
import { getContentOpts } from "sweetalert/typings/modules/options/content";
import { AbpApiResponse } from "@/store/models/common";

const ajax = axios.create({
	baseURL: appconst.remoteServiceBaseUrl,
	timeout: 60000,
});
const tenantNameRegex = /\/\/(http[0-9]?\/)?(.[^./:]+)/g;
const matches = tenantNameRegex.exec(url);
let tokenAuthBkp = Util.abp.utils.getCookieValue(`${appconst.authorization.encrptedAuthTokenName}_backup`);

const getMsgContent = function(msg:string):HTMLElement{
	// replace new line chars.
	const htmlMsg = msg.replace("\n","<br/>");
	const el = document.createElement("span");
	el.innerHTML = htmlMsg;
	return el;
}

ajax.interceptors.request.use(
	function (config) {
		store.commit("asdcom/app/addLoader");
		const token = window.abp.auth.getToken() || (tokenAuthBkp ? window.abp.auth.setToken(tokenAuthBkp) : null);
		if (tokenAuthBkp) {
			Util.abp.utils.deleteCookie(`${appconst.authorization.encrptedAuthTokenName}_backup`);
			tokenAuthBkp = null;
		}
		if (!!token) {
			config.headers.common["Authorization"] = "Bearer " + token;
			//abp.log.debug({"auth header:":config.headers.common["Authorization"]});
		}
		config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");

		const tenantId = window.abp.multiTenancy.getTenantIdCookie();

		if (tenantId) {
			config.headers.common["Abp.TenantId"] = tenantId;
		} else {
			config.headers.common["Abp.TenantName"] = "ocvcapp";
			// if (matches && matches[2]) {
			// 	config.headers.common["Abp.TenantName"] = matches[2];
			// } else {
			// 	console.error(`Cant parse tenantName from ${url} url`);
			// }
		}
		//  console.warn("Authorization: ", config.headers.common["Authorization"]);
		//  console.warn("Token: ", window.abp.auth.getToken());
		// abp.log.debug(` ===> axios request ur: ${config.url}`);
		// abp.log.debug(config);
		abp.log.debug({ desc: `===> API request ${config.url}`, requestConfig: config });
		//abp.log.debug({"===> isSuspectKnown":config.data ? config.data.isSuspectKnown : null})
		// abp.log.debug({desc:"PublicUser flags:", data: `isPublicUserClaimant=${vcClaimStore.state.isPublicUserClaimant}, isPublicUserVictim=${vcClaimStore.state.isPublicUserVictim}`})
		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

//Vue.use(swal);
let vm = new Vue({});
ajax.interceptors.response.use(
	respon => {
		abp.log.debug({ desc: `<=== API response ${respon.config.url}:`, response: respon });
		//abp.log.debug({"<=== isSuspectKnown": respon.data ? respon.data.isSuspectKnown:null})
		// abp.log.debug({desc:"PublicUser flags:", data: `isPublicUserClaimant=${vcClaimStore.state.isPublicUserClaimant}, isPublicUserVictim=${vcClaimStore.state.isPublicUserVictim}`})
		store.commit("asdcom/app/deleteLoader");

		// console.warn(`${respon.config.url } respon.data`, respon.data);

		return respon;
	},
	error => {
		abp.log.debug({ desc: `<=== API ERROR ${error.request.responseURL}`, error: error });
		store.commit("asdcom/app/deleteLoader");
		const okText: any = L("Ok");

		if (error.code === "ECONNABORTED" || (error.response == undefined && error.message == "Network Error")) {
			if (util.abp.localization.sources.length === 0) {
				const msgEl = getMsgContent(`There was an error communicating with the server.\n
			Please wait a few minutes and click "OK" to try again.`);
				swal({
					title: "Error",
					content: { element: msgEl },
					icon: "error",
					buttons: okText,
				}).then(() => {
					location.reload();
				});
			} else {
				swal({
					title: L("Error"),
					//text: L("AnHttpErrorOccured"),
					content: { element: getMsgContent(L("AnHttpErrorOccured",undefined,okText)) },
					icon: "error",
					buttons: okText,
				});
			}
			return Promise.reject(error);
		}

				// if there is error code in the response, we return.
		if (!!error.response && !!error.response.data.error && !!error.response.data.error.code && error.response.data.error.code != 0) {
			const errResp = error.response.data as AbpApiResponse;
			return Promise.reject(errResp);
		}
		else {

			if (!!error.response && !!error.response.data.error && !!error.response.data.error.validationErrors) {
				swal({
					title: L("ValidationErrorsTitle"),
					//text: error.response.data.error.details, //L('ValidationErrorsMessage'),
					content: { element:getMsgContent(error.response.data.error.details) },
					icon: "warning",
					buttons: okText,
				});
			} else {

				if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && !!error.response.data.error.details) {
					swal({
						title: error.response.data.error.message,
						//text: error.response.data.error.details,
						content: { element: getMsgContent(error.response.data.error.details) },
						icon: "error",
						buttons: okText,
					});
				} else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
					swal({
						title: L("Error"),
						//text: error.response.data.error.message, // L("RequestError"),
						content: { element: getMsgContent(error.response.data.error.message) },
						icon: "error",
						buttons: okText,
					});
				} else {
					swal({
						title: L("UnknownError"), //L('Error'),
						icon: "error",
						buttons: okText,
					});
				}
			}
			return Promise.reject(error);
		}
	}
);
export default ajax;
